
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery/catering-delivery-address",
      function () {
        return require("private-next-pages/delivery/catering-delivery-address.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery/catering-delivery-address"])
      });
    }
  